import { CommonModule } from '@angular/common';
import { CardsModule } from 'angular-bootstrap-md';

import { PricingComponent } from './pricing.component';
import { PriceCardComponent } from './price-card/price-card.component';

export const PRICING_COMPONENT_DECLARATIONS = [
  PricingComponent,
  PriceCardComponent,
];

export const PRICING_COMPONENT_IMPORTS = [CommonModule, CardsModule];

export const PRICING_COMPONENT_ENTRY_POINTS = [PriceCardComponent];
